import dynamic from 'next/dynamic'

export const ArticleTopicRow = dynamic(() => import('./article-topic-row'))
